<template>
  <div>
    <form :id="formId">
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.User.username')}}:</div>
              <input
                class="e-input e-input-group"
                :id="baseType + 'username'"
                name="username"
                v-model="account.username"
                maxlength="20"
                @blur="checkAccountName"
                :placeholder="$t('Security.placeholder.username')"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.User.realname')}}:</div>
              <input
                class="e-input e-input-group"
                name="realName"
                v-model="account.realName"
                maxlength="20"
                :placeholder="$t('Security.placeholder.realname')"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>
      <div v-show="showPwd" class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.User.password')}}:</div>
              <input
                type="password"
                class="e-input e-input-group"
                name="password"
                v-model="account.password"
                maxlength="12"
                :placeholder="$t('Security.placeholder.password')"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.User.confirmpwd')}}:</div>
              <input
                type="password"
                class="e-input e-input-group"
                name="confirmPassword"
                :id="baseType+'-confirm'"
                v-model="account.confirmPassword"
                maxlength="12"
                :placeholder="$t('Security.placeholder.confirmpwd')"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.User.email')}}:</div>
              <input
                class="e-input e-input-group"
                name="mail"
                v-model="account.mail"
                maxlength="20"
                :placeholder="$t('Security.placeholder.mail')"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.User.phone')}}:</div>
              <input
                class="e-input e-input-group"
                name="phone"
                v-model="account.phone"
                maxlength="20"
                :placeholder="$t('Security.placeholder.phone')"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-6 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.User.status')}}:</div>
              <ejs-radiobutton :label="$t('Security.User.start')" ref="statusStart" name="status" value="1" :checked="start"></ejs-radiobutton>
              <ejs-radiobutton :label="$t('Security.User.abandon')" ref="statusAbandon" name="status" value="3" :checked="abandon"></ejs-radiobutton>
            </div>
          </div>
        </div>
      </div>
      <div class="row h-row-inputBox">
        <div class="col-sm-12 h-col-inputBox">
          <div class="form-group">
            <div class="e-float-input">
              <div class="h-inputLit">{{$t('Security.User.desc')}}:</div>
              <input
                class="e-input e-input-group"
                name="description"
                v-model="account.description"
                maxlength="40"
              />
            </div>
            <div class="error"></div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import { FormValidator } from '@syncfusion/ej2-vue-inputs';

export default {
  name: 'AccountBase',
  props: {
    baseType: Number,
    formId: String
  },
  data() {
    return {
      account: {
        username: '',
        realName: '',
        password: '',
        confirmPassword: '',
        status: '',
        mail: '',
        phone: '',
        description: ''
      },
      formValidator: '',
      start: true,
      abandon: false,
      showPwd: this.baseType === 0 ? true : false,
      userNameValidStatus: true,
      validateOptions: {
        customPlacement: function(inputElement, errorElement) {
          inputElement = inputElement.closest('.form-group').querySelector('.error');
          inputElement.parentElement.appendChild(errorElement);
        },
        rules: {
          'username': {
            required: [true, `${this.$t('Security.placeholder.username')}`],
            maxLength: [20, `${this.$t('Security.validate.maxLength')}`.replace('{0}', 20)]
          },
          'realName': {
            maxLength: [20, `${this.$t('Security.validate.maxLength')}`.replace('{0}', 20)]
          },
          'password': {
            required: [true, `${this.$t('Security.placeholder.password')}`],
            maxLength: [20, `${this.$t('Security.validate.maxLength')}`.replace('{0}', 20)]
          },
          'confirmPassword': {
            required: [true, `${this.$t('Security.placeholder.confirmpwd')}`],
            maxLength: [20, `${this.$t('Security.validate.maxLength')}`.replace('{0}', 20)]
          },
          'mail': {
            email: [true, `${this.$t('Security.validate.email')}`],
            maxLength: [20, `${this.$t('Security.validate.maxLength')}`.replace('{0}', 20)]
          },
          'phone': {
            regex: ['^([0-9A-Za-z\+\-/#/&])+$',`${this.$t('Security.validate.phone')}`],
            maxLength: [20, `${this.$t('Security.validate.maxLength')}`.replace('{0}', 20)]
          },
          'description': {
            maxLength: [40, `${this.$t('Security.validate.maxLength')}`.replace('{0}', 40)]
          }
        }
      }
    };
  },
  methods: {
    init() {
      this.initStrategy();
      if(!this.showPwd) {
        delete this.validateOptions.rules.username;
        delete this.validateOptions.rules.password;
        delete this.validateOptions.rules.confirmPassword;
        document.getElementById(this.baseType + 'username').disabled = true;
      }
      this.formValidator = new FormValidator('#'+this.formId, this.validateOptions);
    },
    initStrategy() {
      let userStrategy = JSON.parse(sessionStorage.getItem('userStrategy'));
      let pwdStrategy = JSON.parse(sessionStorage.getItem('pwdStrategy'));
      this.validateOptions.rules.username.minLength = [userStrategy['acc.minLength'], `${this.$t('Security.validate.minLength')}`.replace('{0}', userStrategy['acc.minLength'])];
      this.validateOptions.rules.password.minLength = [pwdStrategy['pwd.minLength'], `${this.$t('Security.validate.minLength')}`.replace('{0}', pwdStrategy['pwd.minLength'])];
      this.validateOptions.rules.confirmPassword.minLength = [pwdStrategy['pwd.minLength'], `${this.$t('Security.validate.minLength')}`.replace('{0}', pwdStrategy['pwd.minLength'])];
      if(pwdStrategy['pwd.constitute']==1) {
        this.validateOptions.rules.password.regex = ['^[a-zA-Z0-9]+$', `${this.$t('Security.validate.noSpecial')}`];
        this.validateOptions.rules.confirmPassword.regex = ['^[a-zA-Z0-9]+$', `${this.$t('Security.validate.noSpecial')}`];
      }else {
        this.validateOptions.rules.password.regex = ["[!#$%&*^\'()+,-./:;<=>?@\\[\\\\\\]^`\\{_|\\}~]+", `${this.$t('Security.validate.special')}`];
        this.validateOptions.rules.confirmPassword.regex = ["[!#$%&*^\'()+,-./:;<=>?@\\[\\\\\\]^`\\{_|\\}~]+", `${this.$t('Security.validate.special')}`];
      }
    },
    setbaseInfo(baseInfo) {
      this.account.username = baseInfo.username;
      this.account.realName = baseInfo.realName;
      this.account.mail = baseInfo.mail;
      this.account.phone = baseInfo.phone;
      this.account.description = baseInfo.description;
      if (baseInfo.status==3) {
        this.start = false;
        this.abandon = true;
      }
    },
    getAccountBase() {
      let status = 1;
      if(this.start) {
        status = this.$refs.statusStart.getSelectedValue();
      }else if(this.abandon){
        status = this.$refs.statusAbandon.getSelectedValue();
      }
      return {
        username: this.account.username,
        realName: this.account.realName,
        password: this.account.password,
        status: status,
        mail: this.account.mail,
        phone: this.account.phone,
        description: this.account.description
      }
    },
    validateAccountBase() {
      let status = this.userNameValidStatus;
      if (this.userNameValidStatus) {
        status = this.formValidator.validate();
        let That = this;
        if (this.showPwd && status) {
          // 验证用户名
          let confirm_id = this.baseType + '-confirm';
          if (this.account.password != this.account.confirmPassword) {
            this.setErrorMsg(confirm_id, `${That.$t('Security.pwdNotMatch')}`, 'add');
            status = false;
          } else {
            this.setErrorMsg(confirm_id, '', 'del');
            status = true;
          }
        }
      }
      return status;
    },
    checkAccountName() {
      let That = this;
      this.account.username = this.account.username.trim();
      if (!!this.account.username) {
        this.$axios.get('/lte/ems/user/findOne', { params: { username: this.account.username }}).then(res => {
          let userId = That.baseType + 'username';
          if(res.data!= null && res.data!='') {
            That.setErrorMsg(userId, `${That.$t('Security.userExist')}`, 'add');
            That.userNameValidStatus = false;
          }else {
            That.setErrorMsg(userId, '', 'del');
            That.userNameValidStatus = true;
          }
        });
      }
    },
    setErrorMsg(id, msg, type) {
      if(type==='add') {
        document.getElementById(id).classList.add('e-error');
        document.getElementById(id).parentElement.nextElementSibling.className = 'e-error';
      }else {
        document.getElementById(id).classList.remove('e-error');
        document.getElementById(id).parentElement.nextElementSibling.className = 'error';
      }
      document.getElementById(id).parentElement.nextElementSibling.innerHTML = msg;
    }
  }
};
</script>
